/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorCoverBox from 'base/components/labrador/CoverBox';

export const DynamicLabradorCoverBox: typeof LabradorCoverBox = (props) => {
    return <ErrorBoundary><LabradorCoverBox {...props} /></ErrorBoundary>;
}
export type DynamicLabradorCoverBoxProps = PropsFromComponent<typeof LabradorCoverBox>;
